import { COMMON_WAIFUS, getCommonReviews } from '../../../constants.js';

export const TR_BASE = {
    hero: {
      title: "Waifu Briscola",
      tagline: "Daha önce hiç görmediğiniz Briscola: RPG, Waifu ve Yapay Zeka.",
      ctaWeb: "Web'de Oyna",
      ctaAndroid: "Android için İndir",
      version: "Sürüm 2.3",
      badge: "✨ Yeni Zindan Modu"
    },
    stats: {
      downloads: "İndirmeler",
      downloadsValue: ["Sayılamaz!", "Sunucular Dolu", "Bir sürü!", "9000'den Fazla", "Saymak için çok fazla"],
      hands: "Kaybedilen Eller",
      handsValue: ["Çok fazla...", "Yetenek Sorunu", "Lag yüzünden", "Hala ağlıyorum", "Tekrar dene şanslı olacaksın"],
      rating: "Puanlama",
      ratingValue: ["Büyükannem onaylıyor", "11/10 - IGN", "Pizzadan daha iyi", "GOTY 2026", "Mutlak Başyapıt"],
      waifus: "Waifu",
      waifusValue: ["Hepsi senin için", "Sadece 2D > 3D", "Hepsini topla!", "Waifu > Meta", "Gerçek hazine"]
    },
    features: {
      title: "Bir kart oyunundan çok daha fazlası",
      items: [
        { id: "classic", title: "Klasik Briscola", description: "Orijinal deneyim, mükemmel ve temiz.", icon: "🃏" },
        { id: "roguelike", title: "RPG Roguelike", description: "Kuleye tırman, element güçleri kazan ve patronları yen.", icon: "⚔️" },
        { id: "ai", title: "Canlı Yapay Zeka", description: "Google Gemini sayesinde rakipler seni gerçek zamanlı olarak aşağılar veya över.", icon: "🧠" },
        { id: "gacha", title: "Gacha Sistemi", description: "Yeni görünümler ve nadir arka planlar açmak için paraları kullan.", icon: "💎" },
        { id: "dungeon", title: "Zindan Modu", description: "Çılgın kurallarla patronlarla yüzleş. Bir yenilgi ve biter.", icon: "🏰" },
        { id: "puzzle", title: "Bulmaca Modu", description: "Belirli hedeflerle karmaşık senaryoları çöz.", icon: "🧩" }
      ]
    },
    video: { title: "Oynanış Fragmanı" },
    waifus: {
      title: "Partnerini Seç",
      subtitle: "Her karakterin benzersiz bir kişiliği, seslendirmesi ve oyun tarzı vardır.",
      characters: [
        { ...COMMON_WAIFUS[0], name: "Miu", role: "Tatlı", personality: "Tatlı ve neşeli, yanında olmayı sever." },
        { ...COMMON_WAIFUS[1], name: "Rei", role: "Analitik", personality: "Hesapçı ve soğuk. Sadece mantık." },
        { ...COMMON_WAIFUS[2], name: "Akame", role: "Tsundere", personality: "Rekabetçi ve ateşli. Kaybetmekten nefret eder." },
        { ...COMMON_WAIFUS[3], name: "Lilith", role: "Kraliçe", personality: "Kartların karanlık kraliçesi." },
        { ...COMMON_WAIFUS[4], name: "Mochi", role: "Rehber", personality: "Güvenilir rehberin... belki." }
      ]
    },
    reviews: {
      title: "Hakkımızda diyorlar (maalesef)",
      items: getCommonReviews('tr')
    },
    ctaStrip: {
      title: "Sahaya çıkmaya hazır mısın?",
      subtitle: "Diğer oyunculara katıl ve macerana bugün başla.",
      button: "Şimdi Oynamaya Başla"
    },
    footer: { privacy: "Gizlilik", terms: "Şartlar", copyright: "© 2026 Waifu Briscola" },
    privacy: {
      title: "Waifu Briscola Gizlilik Politikası",
      lastUpdated: "Son güncelleme: 25 Mayıs 2024",
      intro: "Bu Gizlilik Politikası, Waifu Briscola uygulamasını ('Hizmet') kullandığınızda bilgilerinizin nasıl yönetildiğini açıklar.",
      sections: [
        {
          title: "Topladığımız Bilgiler",
          intro: "Deneyiminizi geliştirmek için bilgi toplayabilecek üçüncü taraf hizmetleri kullanıyoruz:",
          items: [
            "Kullanım Verileri (PostHog): Oyunla nasıl etkileşimde bulunduğunuza dair anonim veya takma adlı analiz verileri topluyoruz. Bu, oyunun başlaması, oynanan kartlar ve nihai sonuçlar gibi etkinlikleri içerir. Bu veriler, oyunun nasıl kullanıldığını ve onu nasıl geliştirebileceğimizi anlamamıza yardımcı olur. PostHog aracılığıyla Kişisel Tanımlanabilir Bilgi (PII) toplamıyoruz.",
            "Yapay Zeka Etkileşimleri (Google Gemini): Gönderdiğiniz sohbet mesajları ve oyun durumu hakkındaki bilgiler (elinizdeki ve masadaki kartlar gibi), yapay zekanın yanıtlarını ve hamlelerini oluşturmak için Google Gemini API'sine gönderilir. Bu etkileşimler Google'ın Gizlilik Politikasına tabidir. Oyun etkileşimlerinizin içeriği dışında Google'a hiçbir kişisel bilgi göndermiyoruz.",
          ],
        },
        {
          title: "Bilgilerinizi Nasıl Kullanıyoruz",
          intro: "Toplanan bilgileri şunlar için kullanıyoruz:",
          items: [
            "Hizmetimizi sağlamak, işletmek ve sürdürmek.",
            "Hizmetimizi geliştirmek, kişiselleştirmek ve genişletmek.",
            "Hizmetimizi nasıl kullandığınızı anlamak ve analiz etmek.",
            "Kötüye kullanımı önlemek ve güvenliği sağlamak.",
          ],
        },
        {
          title: "Bilgi Paylaşımı",
          body: "Uygulamanın çalışması için gerekli olan üçüncü taraf hizmet sağlayıcıları (PostHog, Google) dışında kişisel bilgilerinizi kimseyle paylaşmıyoruz, yukarıda açıklandığı gibi.",
        },
        {
          title: "Veri Güvenliği",
          body: "Bilgilerinizin güvenliği bizim için önemlidir, ancak İnternet üzerinden hiçbir iletim yönteminin veya elektronik depolama yönteminin %100 güvenli olmadığını unutmayın.",
        },
        {
          title: "Bu Gizlilik Politikasındaki Değişiklikler",
          body: "Gizlilik Politikamızı zaman zaman güncelleyebiliriz. Herhangi bir değişikliği bu sayfada yeni Gizlilik Politikasını yayınlayarak size bildireceğiz.",
        },
        {
          title: "Bize Ulaşın",
          body: "Bu Gizlilik Politikası hakkında sorularınız varsa, sorumlu Mauro Mazzocchetti ile iletişime geçebilirsiniz.",
        },
      ],
    },
    consent: { text: "Siteyi geliştirmek için çerezler ve analitik kullanıyoruz. Devam ederek şunları kabul edersiniz:", ok: "Anladım" },
    terms: {
      title: "Waifu Briscola Şartlar ve Koşullar",
      lastUpdated: "Son güncelleme: 25 Mayıs 2024",
      contact: "Sorumlu: Mauro Mazzocchetti",
      intro: "Waifu Briscola'ya hoş geldiniz! Bu şartlar ve koşullar, Waifu Briscola uygulamasının ('Hizmet') kullanım kurallarını özetlemektedir.",
      sections: [
        {
          title: "Şartların Kabulü",
          body: "Bu Hizmete erişerek ve kullanarak, bu Şartlara bağlı kalmayı kabul edersiniz. Şartların herhangi bir kısmını kabul etmiyorsanız, Hizmeti kullanamazsınız.",
        },
        {
          title: "Hizmetin Kullanımı",
          body: "Hizmeti yasa dışı veya yetkisiz amaçlarla kullanmamayı kabul edersiniz. Davranışlarınızdan ve Hizmeti kullanırken sağladığınız sohbet mesajları dahil her türlü içerikten siz sorumlusunuz.",
        },
        {
          title: "Yapay Zeka Tarafından Oluşturulan İçerik",
          intro: "Hizmet, yanıtlar, yorumlar ve oyun hamleleri oluşturmak için yapay zeka modelleri (Google Gemini) kullanır. Şunları kabul edersiniz:",
          items: [
            "Yapay zeka tarafından oluşturulan içerik bir model tarafından üretilir ve her zaman doğru, uygun veya tutarlı olmayabilir.",
            "Yapay zeka tarafından oluşturulan içerikten sorumlu değiliz.",
            "Yapay zeka ile etkileşimler yalnızca eğlence amaçlıdır.",
          ],
        },
        {
          title: "Sorumluluk Sınırlaması",
          body: "Hiçbir durumda Mauro Mazzocchetti veya ortakları, (i) Hizmete erişiminiz veya kullanımınız veya erişememeniz veya kullanamamanızdan; (ii) Hizmetten elde edilen herhangi bir içerikten kaynaklanan kar kaybı, veri kaybı, iyi niyet kaybı veya diğer maddi olmayan kayıplar dahil ancak bunlarla sınırlı olmamak üzere, dolaylı, arızi, özel, sonuçsal veya cezai zararlardan sorumlu tutulamaz.",
        },
        {
          title: "Şartlardaki Değişiklikler",
          body: "Kendi takdirimize bağlı olarak, bu Şartları istediğimiz zaman değiştirme veya yerine yenisini koyma hakkını saklı tutarız. Herhangi bir değişikliği bu sayfada yeni şartları yayınlayarak size bildireceğiz.",
        },
        {
          title: "Geçerli Hukuk",
          body: "Bu Şartlar, kanunlar ihtilafı hükümlerine bakılmaksızın İtalyan yasalarına göre yönetilecek ve yorumlanacaktır.",
        },
      ],
    }
};
